import { useNavigate, useResolvedPath } from "react-router";
import useBreakpoint from "../../hooks/useBreakpoint";
import { useGlobalContext } from "../../stores/Global";
import SideBarButtonBase from "./SideBarButtonBase";

interface MainSideBarButtonProps {
  icon?: any;
  value: string;
  path?: string;
  onClick?: () => any;
}

export default function MainSideBarButton(props: MainSideBarButtonProps) {
  const { context, setContext } = useGlobalContext();
  const { pathname } = useResolvedPath("");
  const isMatched = pathname === props.path;
  const navigate = useNavigate();
  const breakpoint = useBreakpoint();

  const handleClick = () => {
    if (!breakpoint.md && !props.onClick)
      setContext({ ...context, sidebar: false });
    if (props.path) navigate(props.path);
    if (props.onClick) props.onClick();
  };

  return (
    <SideBarButtonBase
      matched={isMatched}
      value={props.value}
      onClick={handleClick}
      icon={props.icon}
    />
  );
}
